import { Component, Input, OnInit } from '@angular/core';
import { DialogContentBase, DialogRef } from '@progress/kendo-angular-dialog';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faCircleUser } from '@fortawesome/free-regular-svg-icons';
import {
  PresentDialogStudentInfo,
  StudentPresentSessionDetails,
} from '../../interfaces/service-entry-details';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import { ReferenceService } from 'src/app/services/reference.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { StudentDocument } from '../../interfaces/student-document';
import { PdfAndImageService } from 'src/app/services/pdf-image.service';
import { DocumentService } from 'src/app/services/document.service';
import { LoadingService } from 'src/app/services/loading.service';

@Component({
  selector: 'app-encounter-attendance-absent',
  templateUrl: './encounter-attendance-absent.component.html',
  styleUrls: ['./encounter-attendance-absent.component.scss'],
  standalone: false,
})
export class EncounterAttendanceAbsentComponent
  extends DialogContentBase
  implements OnInit {
  @Input() studentInfo: PresentDialogStudentInfo | undefined;
  @Input() studentPresentDetails: StudentPresentSessionDetails | undefined;
  @Input() studentAbsentDetails:
    | { sessionTypeId: number; sessionNotes: string }
    | undefined;
  @Input() existingDocuments: StudentDocument[] = [];
  @Input() meetingStartTime: Date | null = null;
  sessionTypes: IReferenceData[] = [];
  selectedSessionTypeId: number | null = null;
  form!: FormGroup;
  faCircleUser = faCircleUser;

  constructor(
    dialogRef: DialogRef,
    public documentService: DocumentService,
    public loadingService: LoadingService,
    private pdfAndImageService: PdfAndImageService,
    private library: FaIconLibrary,
    private referenceService: ReferenceService,
    private fb: FormBuilder,
  ) {
    super(dialogRef);
    this.library.addIcons(faCircleUser);
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      sessionTypeId: [
        this.studentAbsentDetails?.sessionTypeId ?? null,
        Validators.required,
      ],
      attachments: [[] as File[]],
    });
    this.loadSessionTypes();
    if (this.studentAbsentDetails) {
      this.form
        .get('sessionTypeId')
        ?.setValue(this.studentAbsentDetails.sessionTypeId ?? null, {
          emitEvent: false,
        });
    }
  }

  onFilesChange(files: File[]): void {
    this.form.get('attachments')?.setValue(files);
  }

  get hasExistingDocuments(): boolean {
    return (this.existingDocuments?.length ?? 0) > 0;
  }

  loadSessionTypes(): void {
    this.referenceService
      .getDropDownValues('EncounterSessionType')
      .subscribe((res: IReferenceData[]) => {
        this.sessionTypes = res || [];
      });
  }

  onSave(): void {
    this.form.markAllAsTouched();
    if (this.form.invalid) {
      return;
    }

    const result: {
      studentSk: string;
      sessionTypeId: number;
      attachments: File[];
    } = {
      studentSk: this.studentInfo?.studentSk,
      sessionTypeId: this.form.get('sessionTypeId')?.value,
      attachments: this.form.get('attachments')?.value ?? [],
    };

    this.dialog.close(result);
  }
    downloadDocument(documentRow: StudentDocument): void {
    this.loadingService.show();
    this.documentService

      .getDocument(documentRow.documentRef)

      .subscribe((response: Uint8Array<ArrayBufferLike>) => {

        this.pdfAndImageService.download(

          response,

          documentRow.documentFormat,

          documentRow.documentName

        );
        this.loadingService.hide();
      });

  }
}
